import $ from 'jquery'
import Marionette from 'backbone.marionette'
import session from 'models/sessionInstance'
import LayoutController from 'controllers/layoutController'
import users from 'collections/usersInstance'
import vent from 'libraries/vent'
import { authUrl } from 'config/backend'

var ApplicationController = Marionette.Controller.extend({
  initialize: function (options) {
    this.options = options;
    this._createApplicationRegion();
    this._registerEventListeners();
    this._registerCommandHandlers();
  },
  _createApplicationRegion: function () {
    this.applicationRegion = new Marionette.Region({
      el: '#layout'
    });
  },
  _createLayoutController: function () {
    this.layoutController = new LayoutController();
  },
  _registerEventListeners: function () {
    this.listenTo(users, 'changed:currentUser', this.refreshHeader);
  },
  _registerCommandHandlers: function () {
    vent.commands.setHandler('logout', this.logout);
    vent.commands.setHandler('unswitch', this.unswitchUser);
  },
  brandLayout: function () {
    $('body').addClass(session.get('brand_theme'));
  },
  renderLayout: function () {
    this._createLayoutController();
    this.layoutController.show(this.applicationRegion);
  },
  logout: function () {
    // After logout the user has no session, so we chain through /login:
    //   /logout?redirect=/login?redirect=<webapp-url>
    // Backend logs out, redirects to /login, user authenticates, then lands back on webapp.
    var loginWithReturn = '/login?redirect=' + encodeURIComponent(window.location.href);
    window.location.href = authUrl('/logout', { redirect: loginWithReturn });
  },
  unswitchUser: function () {
    window.location.href = authUrl('/unswitch_user', { redirect: window.location.href });
  },
  refreshHeader: function () {
    this.layoutController.refreshHeader()
  }
});

export default ApplicationController;
